export default __webpack_public_path__ + "static/normalized_forbes-4813581693b7733bf17f1c9d454ecd30.svg";